import { defineComponent as _defineComponent } from 'vue'
import {
  ApplyForMissionStaffingPositionMutation,
  ApplyForMissionStaffingPositionMutationMutation,
  ApplyForMissionStaffingPositionMutationMutationVariables,
} from "@/gql"
import { ref, watch } from "vue"
import { useMutation } from "@/hooks/useMutation"
import { useNotification } from "@/hooks/useNotification"
import { RefetchQueryDescription } from "apollo-client/core/watchQueryOptions"
import { useTranslation } from "@/i18n/useTranslation"


export default /*#__PURE__*/_defineComponent({
  __name: 'ApplyForRoleModal',
  props: {
    staffingPositionId: null,
    refetchQueries: null,
    showConfirmModal: { type: Boolean }
  },
  emits: ["close"],
  setup(__props: any, { emit }: { emit: ({
  (e: "close"): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  staffingPositionId: string
  refetchQueries: RefetchQueryDescription
  showConfirmModal: boolean
}





const { mutate } = useMutation()
const { addSuccess, addError } = useNotification()
const { t } = useTranslation("Consultant/Opportunities")

const showModal = ref(false)

watch(
  () => props.showConfirmModal,
  (value) => {
    showModal.value = value
  },
  {
    immediate: true,
  }
)

const isSubmitting = ref(false)
const form = ref({
  expressionOfInterest: "",
})

const onApplyForStaffingOpportunity = async () => {
  if (!props.staffingPositionId) return

  isSubmitting.value = true

  await mutate<
    ApplyForMissionStaffingPositionMutationMutation,
    ApplyForMissionStaffingPositionMutationMutationVariables
  >({
    mutation: ApplyForMissionStaffingPositionMutation,
    variables: {
      expressionOfInterest: form.value.expressionOfInterest,
      id: props.staffingPositionId,
    },
    refetchQueries: props.refetchQueries,
    handlePayloadErrors: false,
    done: () => {
      isSubmitting.value = false
    },
    onSuccess: () => {
      addSuccess(t("applicationSubmitted"))
      onClose()
    },
    onMutationError: (error) => {
      addError(error.message)
    },
  })
}

const onClose = () => {
  showModal.value = false
  form.value.expressionOfInterest = ""
  emit("close")
}

return { __sfc: true,props, emit, mutate, addSuccess, addError, t, showModal, isSubmitting, form, onApplyForStaffingOpportunity, onClose }
}

})